import TStandardGuide from './t-standard-guide';

export default TStandardGuide;